export default {
  "settings": {
    "title": "Paramètres",
    "screen": {
      "organization": "Paramètres de l'organisation",
      "workspace": "Paramètres de l'espace de travail",
      "members": "Membres",
      "connections": "Connexions",
      "account": "Compte"
    },
    "section": {
      "workspace": "Espace de travail · {name}",
      "organization": "Organisation · {name}",
      "personal": "Vous"
    },
    "connectionsTab": {
      "desc": "Les sources dont cet espace de travail tire ses données."
    },
    "membersTab": {
      "desc": "Qui peut ouvrir l'espace de travail {workspaceName}, et avec quel rôle."
    },
    "homeTab": {
      "header": "Accueil",
      "title": "Accueil",
      "desc": "La page d'arrivée de tous les membres de l'espace de travail {workspaceName}. Chaque espace de travail a son propre accueil.",
      "current": "Tableau de bord d'accueil",
      "change": "Changer de tableau de bord",
      "preview": "Aperçu de l'accueil",
      "clear": "Retirer le tableau de bord d'accueil",
      "clearHint": "Tout le monde voit l'état vide jusqu'à ce qu'un nouveau soit choisi.",
      "none": "Aucun tableau de bord d'accueil pour l'instant. Tous les membres de cet espace de travail voient l'état vide.",
      "missing": "Le tableau de bord d'accueil n'est plus disponible. Choisissez-en un autre.",
      "switchNote": "Changer d'espace de travail change aussi l'accueil. Chaque espace de travail a son propre tableau de bord d'accueil, défini dans ses propres paramètres."
    }
  }
};
